import { LOANS } from 'loans.module/common/domain/constants.loans';
import { EVENTS, MODALS } from 'common/domain/constants';
import { STATES } from 'common/domain/states';

class RequestCardSimulationFamilyController {
  constructor(EventEmitter, $stateParams, $rootScope, $state, $window, LoansNeedALoanService) {
    'ngInject';
    this.eventEmitter = EventEmitter;
    this.stateParams = $stateParams;
    this.rootScope = $rootScope;
    this.state = $state;
    this.window = $window;
    this.isMobileApp = $window.innerWidth < 1024;
    this.loansNeedALoanService = LoansNeedALoanService;
    this.snapshotSimulation = this.loansNeedALoanService.getDataSimulation();
  }

  $onInit() {
    this.rootScope.$broadcast(EVENTS.CHANGE_TITLE, { title: 'LOANS.NEED_A_LOAN.RESULTS' });

    if (!this.isMobileApp) {
      this.initData();
      this.scrollToResults();
    }

    if (this.stateParams.snapshot || this.snapshotSimulation) {
      this.initFromSnapshot();
    }

    if (this.isMobileApp && this.loanSimulationRequest === undefined) {
      this.state.go(STATES.LOANS.NEED_A_LOAN);
    }
  }

  initData() {
    this.loanSimulationRequest = this.loanSimulation;
    this.simulation = this.loanSimulationRequest.simulation;
    this.familySelected = this.itemSelected;
    this.optionFamilySelected = this.codeLoanSimulation;
    this.families = this.family;
    this.codeOptionSelected = this.codeOption;
    this.creditworthiness = this.myCreditworthiness;
  }

  initFromSnapshot() {
    this.snapshot = this.snapshotSimulation || this.stateParams.snapshot;

    if (this.snapshot.loanSimulationRequest) {
      this.loanSimulationRequest = this.snapshot.loanSimulationRequest;
    }

    this.loanSimulation = this.snapshot.loanSimulation;
    this.familySelected = this.snapshot.familySelected;
    this.optionFamilySelected = this.snapshot.optionFamilySelected;
    this.families = this.snapshot.families;
    this.codeOptionSelected = this.snapshot.codeOptionSelected;
    this.creditworthiness = this.myCreditworthiness;
    this.simulation = this.snapshot.simulation;

    if (!this.creditworthiness) {
      this.creditworthiness = this.snapshot.creditworthiness;
    }

    if (!this.housingWitness) {
      this.housingWitness = this.creditworthiness.housingWitness;
    }

    if (!this.simulationWitness) {
      this.simulationWitness = this.creditworthiness.simulationWitness;
    }

    // Only store the snapshot on mobile: In desktop this is done by the need a loan controller
    if (this.isMobileApp) {
      this.loansNeedALoanService.setDataSimulation(this.snapshot);
    }
  }

  get modal() {
    const $modal = $(MODALS.NEED_A_LOAN);
    return $modal;
  }

  openDetail(loanSimulation) {
    let dataToDetail = {
      loanId: loanSimulation.id,
      allowGoBack: !this.isMobileApp,
      loanSimulationRequest: this.loanSimulationRequest,
      simulation: this.simulation,
      familySelected: this.familySelected,
      optionFamilySelected: this.optionFamilySelected,
      families: this.families,
      codeOptionSelected: this.codeOptionSelected,
    };

    this.loansNeedALoanService.onOpenDetail(dataToDetail);
  }

  checkLoanSimulationRequest() {
    return this.loanSimulationRequest !== undefined;
  }

  checkSimulationIsOkey(loanSimulation) {
    if (loanSimulation === undefined) return;
    return loanSimulation.status.code === LOANS.STATUS.OK;
  }

  selectLoan(loanSimulation, isSignUp) {
    let response = this.loansNeedALoanService.onSelectLoan({
      loanId: loanSimulation.id,
      loanSimulation: loanSimulation,
      creditworthiness: this.creditworthiness,
      simulation: this.simulation,
      dataToGoBack: this.snapshot,
    }, isSignUp);

    if (response !== undefined) {
      return this.presentCannotSignUpModal(response);
    }
  }

  presentCannotSignUpModal(reason) {
    this.cannotSignUpError = reason;
    this.modal.modal('show');
  }

  isFiveOrNineMonth(loanId) {
    return loanId === LOANS.ID.FIVE_MONTH || loanId === LOANS.ID.NINE_MONTH;
  }

  isSocialAgreement(loanId) {
    return loanId === LOANS.ID.AGREEMENT_HOUSING_LOAN;
  }

  showIconInfoOnAmount() {
    return false;
  }

  showIconInfoOnInterests(loanId) {
    return !this.isFiveOrNineMonth(loanId);
  }

  showIconInfoOnDeadline() {
    return true;
  }

  showIconInfoOnInsurance(loanSimulation) {
    return loanSimulation.wantInsurance;
  }

  showLoanCV(loanId) {
    return loanId === LOANS.ID.VARIOUS_CREDIT;
  }

  showLoanDA(loanId) {
    return loanId === LOANS.ID.DIVERSAL_ATENTION;
  }

  showLoanVC(loanId) {
    return loanId === LOANS.ID.AGREEMENT_HOUSING_LOAN;
  }

  showLoanSV(loanId) {
    return loanId === LOANS.ID.SOCIAL_HOUSING_LOAN;
  }

  showLoan9S(loanId) {
    return loanId === LOANS.ID.NINE_MONTH;
  }

  showLoan5S(loanId) {
    return loanId === LOANS.ID.FIVE_MONTH;
  }

  modifyLoan() {
    if (this.isMobileApp) return this.state.go(STATES.LOANS.NEED_A_LOAN);
    this.onModifyLoan();
  }

  goMyLoans() {
    this.state.go(STATES.LOANS.MY_LOANS);
    this.modal.modal('hide');
  }

  showSalePrice(loanSimulation) {
    return (
      loanSimulation.loanPurposeId === LOANS.ID_HR.HOUSING_MANDATORY_PURPOSE &&
      (this.housingWitness === true || this.simulationWitness === true)
    );
  }
  selectButtonShouldAppear() {
    return this.simulationWitness && (this.codeOptionSelected === LOANS.ID_HR.HOUSING_MANDATORY_PURPOSE || this.codeOptionSelected === LOANS.ID_HR.SOCIAL_HOUSING_LOAN || this.codeOptionSelected === LOANS.ID_HR.AGREEMENT_HOUSING_LOAN);
  }

}

export default RequestCardSimulationFamilyController;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/needALoan/requestCardSimulationFamily/requestCardSimulationFamily.controller.js